<div class="body">

    <div class="afiliado" *ngIf="rol == 'ROLE_AFILIADO' &&  this.solicitud =='convenio'">

        <div class="container" style="height:100px"> </div>

        <div class="container" id="tabla" style="background-color: white; padding-top: 50px; padding-bottom:50px">

            <div class="row">

                <div class="col-lg-5">
                    <h1> Postulaciones Convenio </h1>
                </div>

                <div class="col-lg-4"> </div>

                <div class="col-lg-2">
                    <h3> Cantidad de Registros </h3>
                </div>

                <div class="col-lg-1">

                    <select class="form-control">

                        <option value = "5">5</option>
                        <option value = "10">10</option>
                        <option value = "20">20</option> 
                        <option value = "30">30</option>
                        <option value = "50">50</option>

                    </select> </div>

            </div>
            <div class="row">
                <div class="col-lg-9">
                    <h1> </h1>
                </div>
                <div class="col-lg-2">

                    <button class="mat-raised-button btn-success" (click)="cargaSolicitudesCodeudor()">
        
                 Ver Solicitudes de Codeudor</button>

                </div>
            </div>
            <br/>
            <hr/> <br/>

            <div class="table-responsive">

                <table class="table">

                    <thead>

                        <tr style="background-color: #0f69b4;color:white;">
                            <th>N°</th>
                            <th>Fecha Ingreso</th>
                            <th>Categoría de Atención</th>
                            <th>Región</th>
                            <th>Proveedor</th>
                            <th>Monto Solicitado</th>
                            <th>Cantidad de Cuotas</th>
                            <th>Rut Codeudor 1</th>
                            <th>Nombre Codeudor 1</th>
                            <th>Estado Codeudor 1</th>
                            <th>Rut Codeudor 2</th>
                            <th>Nombre Codeudor 2</th>
                            <th>Estado Codeudor 2</th>
                            <th>Estado</th>
                            <th>Ejecutivo</th>
                            <th>Motivo Rechazo</th>
                            <th>Ver Archivo(s)</th>
                            <th>Anular</th>


                        </tr>

                    </thead>

                    <tbody>

                        <tr [class]="i % 2 == 0 ? 'rowEven' : 'rowOdd'" *ngFor="let pago of postulaciones | paginate: config; let i = index">

                            <td style="text-align: center;"><a style="cursor:pointer; text-decoration: underline" (click)="openEditDialogValidarConvenio(pago.idPostulacion,  false,false)">{{pago.idPostulacion}}</a> </td>
                            <td style="text-align: center;">{{pago.fechaIngreso}}</td>
                            <td style="text-align: center;">{{pago.tipoConvenioString}}</td>
                            <td style="text-align: center;">{{pago.regionConvenio}}</td>
                            <td style="text-align: center;">{{pago.nombreCorto}} </td>
                            <td style="text-align: center;">{{pago.montoSolicitado}}</td>
                            <td style="text-align: center;">{{pago.cantidadCuota}}</td>

                            <td style="text-align: center;"><a style="cursor:pointer; text-decoration: underline" (click)="detalleBeneficiario(pago.rutCodeudorUno)"> {{pago.rutCodeudorUno}} </a> </td>
                            <td style="text-align: center;">{{pago.nombreCodeudorUno}}</td>
                            <td style="text-align: center;">{{pago.estadoCodeudorUno}}</td>
                            <td style="text-align: center;"> <a style="cursor:pointer; text-decoration: underline" (click)="detalleBeneficiario(pago.rutCodeudorDos)"> {{pago.rutCodeudorDos}} </a> </td>
                            <td style="text-align: center;">{{pago.nombreCodeudorDos}}</td>
                            <td style="text-align: center;">{{pago.estadoCodeudorDos}}</td>
                            <td style="text-align: center;">{{pago.estado}}</td>
                            <td style="text-align: center;">{{pago.nombreEjecutivo}}</td>
                            <td style="text-align: center;">{{pago.descripcionRechazo}}</td>
                            <td style="text-align: center;">
                                <p>
                                    <button class="mat-raised-button btn-info" (click)="onDescargarArchivosClick(pago.idPostulacion)">
                    
                                <i class = "fa fa-download"> </i> Ver</button>
                                </p>
                            </td>
                            <td *ngIf="pago.estado == 'PENDIENTE' || pago.estado == 'INGRESADA'" style="text-align: center;"><button style="width: 120px" class="btn btn-danger" (click)="openDialogAnular(pago.idPostulacion, pago.rutUsuario)"> <!--*ngIf="pre.estado == 'INGRESADA' "-->

                                <i class = "fa fa-trash"> </i> Anular

                            </button></td>

                        </tr>

                    </tbody>

                </table> <br/>

                <pagination-controls style="text-align: center" previousLabel="Anterior" nextLabel="Siguiente" (pageChange)="pageChanged($event)" autoHide="true"> </pagination-controls>

            </div>

        </div>

        <div class="container" style="height:100px"> </div>

    </div>
    <div class="afiliado" *ngIf="rol == 'ROLE_AFILIADO' && this.solicitud =='codeudor'">

        <div class="container" style="height:100px"> </div>

        <div class="container" id="tabla" style="background-color: white; padding-top: 50px; padding-bottom:50px">

            <div class="row">

                <div class="col-lg-5">
                    <h1> Solicitudes Codeudor Convenio</h1>
                </div>

                <div class="col-lg-4"> </div>

                <div class="col-lg-2">
                    <h3> Cantidad de Registros </h3>
                </div>

                <div class="col-lg-1">

                    <select class="form-control">

                        <option value = "5">5</option>
                        <option value = "10">10</option>
                        <option value = "20">20</option> 
                        <option value = "30">30</option>
                        <option value = "50">50</option>

                    </select> </div>

            </div>
            <div class="row">
                <div class="col-lg-9">
                    <h1> </h1>
                </div>
                <div class="col-lg-2" *ngIf="rol == 'ROLE_AFILIADO'">

                    <button class="mat-raised-button btn-success" (click)="postulacionesDisponibles()">
        
                 Ver Solicitudes Disponibles</button>

                </div>

            </div>
            <br/>
            <hr/> <br/>

            <div class="table-responsive">

                <table class="table">

                    <thead>

                        <tr style="background-color: #0f69b4;color:white;">
                            <th>N°</th>
                            <th>Fecha Ingreso</th>
                            <th>Rut Solicitante</th>
                            <th>Nombre Solicitante</th>
                            <th>Categoría de Atención</th>
                            <th>Región</th>
                            <th>Proveedor</th>
                            <th>Monto Solicitado</th>
                            <th>Cantidad de Cuotas</th>
                            <th>Estado</th>
                            <th>Ver Archivo</th>
                            <th>Revisar</th>
                        </tr>

                    </thead>

                    <tbody>

                        <tr [class]="i % 2 == 0 ? 'rowEven' : 'rowOdd'" *ngFor="let pago of postulaciones | paginate: config; let i = index">
                            <td style="text-align: center;"><a style="cursor:pointer; text-decoration: underline" (click)="openEditDialogValidarConvenio(pago.idPostulacion,  false,false)">{{pago.idPostulacion}}</a> </td>
                            <td style="text-align: center;">{{pago.fechaIngreso}}</td>
                            <td style="text-align: center;" *ngIf="pago.idCarga != 0"> {{pago.rutCarga}} </td>
                            <td style="text-align: center;" *ngIf="pago.idCarga == 0"> <a style="cursor:pointer; text-decoration: underline" (click)="detalleBeneficiario(pago.rutUsuario)"> {{pago.rutUsuario}} </a> </td>
                            <td style="text-align: center;" *ngIf="pago.idCarga != 0">{{pago.nombreCarga}}</td>
                            <td style="text-align: center;" *ngIf="pago.idCarga == 0">{{pago.nombreUsuario}}</td>
                            <td style="text-align: center;">{{pago.tipoConvenioString}}</td>
                            <td style="text-align: center;">{{pago.regionConvenio}}</td>
                            <td style="text-align: center;">{{pago.nombreCorto}} </td>
                            <td style="text-align: center;">{{pago.montoSolicitado}}</td>
                            <td style="text-align: center;">{{pago.cantidadCuota}}</td>

                            <td style="text-align: center;">{{pago.estado}}</td>
                            <td style="text-align: center;">
                                <p>
                                    <button class="mat-raised-button btn-info" (click)="onDescargarArchivosClick(pago.idPostulacion)">
                    
                                    <i class = "fa fa-download"> </i> Ver</button>
                                </p>
                            </td>

                            <td *ngIf="pago.estado == 'PENDIENTE'">
                                <p><button class="btn-success" (click)="openDialogCodeudorConvenio(pago.idPostulacion,true)">
                                    <i class = "fa fa-money-bill-alt"> </i> Aceptar/Rechazar</button></p>
                            </td>
                            <td *ngIf="pago.estado != 'PENDIENTE'">
                                <p><button class="btn-success" (click)="openDialogCodeudorConvenio(pago.idPostulacion,false)">
                                    <<i class = "fa fa-pen"> </i> Revisar</button></p>
                            </td>
                            <td style="text-align: center;"></td>

                        </tr>

                    </tbody>

                </table> <br/>

                <pagination-controls style="text-align: center" previousLabel="Anterior" nextLabel="Siguiente" (pageChange)="pageChanged($event)" autoHide="true"> </pagination-controls>

            </div>

        </div>

        <div class="container" style="height:100px"> </div>

    </div>

    <div class="afiliado" *ngIf="rol != 'ROLE_AFILIADO'  &&  this.solicitud =='convenio'">

        <div class="container" style="height:100px"> </div>

        <div class="container" id="tabla" style="background-color: white; padding-top: 50px; padding-bottom:50px">

            <div class="row">

                <div class="col-lg-4">
                    <h1> Postulaciones Convenio {{tipoPostulacion}} </h1>
                </div>

                <div class="col-lg-2"> </div>

                <div class="col-lg-3" *ngIf="tipoPostulacion == 'Asignadas'">

                    <button class="btn btn-info" (click)="postulacionesDisponiblesBuscador()"> Solicitudes Disponibles </button>
                </div>

                <div class="col-lg-3" *ngIf="tipoPostulacion == 'Disponibles'">

                    <button class="btn btn-info" (click)="postulacionesAsignadas(true)"> Solicitudes Asignadas </button>

                </div>

                <div class="col-lg-2">
                    <h3> Cantidad de Registros </h3>
                </div>

                <div class="col-lg-1">

                    <select class="form-control" (change)="buscar()" [(ngModel)]="buscador.itemsPerPage">

                        <option value = "5">5</option>
                        <option value = "10">10</option>
                        <option value = "20">20</option>
                        <option value = "30">30</option>
                        <option value = "50">50</option>

                    </select> </div>

            </div>
            <hr/> <br/>

            <div>

                <div class="row">

                    <div class="col-lg-2">
                        <h3> RUT de Usuario: </h3>
                    </div>

                    <div class="col-lg-3">

                        <input name="rut" class="form-control" type="text" #rut="ngModel" [(ngModel)]="buscador.rut" type="text" placeholder="Ingrese el RUT (11111111-1)" pattern="[0-9.]{7,10}[-]{1}[0-9Kk]{1}" />

                    </div>
                    <div class="col-lg-2" *ngIf="this.rol == 'ROLE_ADMINISTRADOR' || this.rol == 'ROLE_ENCARGADO_NACIONAL' || this.rol == 'ROLE_COORDINADOR' || this.rol == 'ROLE_ENCARGADO_CONTABILIDAD'  || this.rol == 'ROLE_CONTABILIDAD' || this.rol == 'ROLE_ASISTENTE_SOCIAL'">
                        <h3> Región: </h3>
                    </div>

                    <div class="col-lg-3" *ngIf="this.rol == 'ROLE_ADMINISTRADOR' || this.rol == 'ROLE_ENCARGADO_NACIONAL' || this.rol == 'ROLE_COORDINADOR' || this.rol == 'ROLE_ENCARGADO_CONTABILIDAD'  || this.rol == 'ROLE_CONTABILIDAD' || this.rol == 'ROLE_ASISTENTE_SOCIAL'"> 

                        <mat-select [(ngModel)]="buscador.region" #region="ngModel" [disabled]="this.rol != 'ROLE_ADMINISTRADOR' && this.rol != 'ROLE_ENCARGADO_NACIONAL'  && this.rol != 'ROLE_COORDINADOR'  && this.rol != 'ROLE_ENCARGADO_CONTABILIDAD'  && this.rol != 'ROLE_CONTABILIDAD' && this.rol != 'ROLE_ASISTENTE_SOCIAL'">

                            <mat-option value="0">

                                SELECCIONE....

                            </mat-option>

                            <mat-option *ngFor="let region of regiones" value="{{region.id}}">

                                {{region.nombre}}

                            </mat-option>

                        </mat-select>

                    </div>

                    <div class="col-lg-2"> </div>

                </div> <br/>

                <div class="row">

                    <div class="col-lg-2">
                        <h3> ID Solicitud: </h3>
                    </div>

                    <div class="col-lg-3">

                        <input class="form-control" type="number" pattern="[0-9]" [(ngModel)]="buscador.idSolicitud" #idSolicitud="ngModel" />

                    </div>

                    <div class="col-lg-2">
                        <h3> Estados: </h3>
                    </div>

                    <div class="col-lg-3">

                        <mat-select multiple [(ngModel)]="buscador.estadoselect">

                            <mat-option *ngFor="let esta of estado" value="{{esta}}">

                                {{esta}}

                            </mat-option>

                        </mat-select>

                    </div>

                    <div class="col-lg-2"> </div>

                </div> <br/>


                <div class="row">

                    <div class="col-lg-2">
                        <h3> Fecha Inicio: </h3>
                    </div>

                    <div class="col-lg-3">

                        <input name="fechaInicio" class="form-control" type="date" class="form-control" type="date" placeholder="Ingrese la fecha Inicio" [(ngModel)]="buscador.fechaInicio" #fechaInicio="ngModel" />

                    </div>

                    <div class="col-lg-2">
                        <h3> Fecha Fin: </h3>
                    </div>

                    <div class="col-lg-3">
                        <input name="fechaFin" class="form-control" type="date" placeholder="Ingrese la fecha Fin" #fechaFin="ngModel" [(ngModel)]="buscador.fechaFin" />
                    </div>

                    <div class="col-lg-2"> <button class="btn btn-info" (click)="buscar()">

                        <i class = "fa fa-search"></i> Buscar </button>

                    </div>

                </div>
                <hr/> <br/>

                <div class="row" *ngIf="tipoPostulacion == 'Disponibles'">

                    <div class="col-lg-2">
                        <h3>
                            <mat-checkbox color="primary" [checked]="allComplete" [indeterminate]="someComplete()" (change)="setAll($event.checked)"> Seleccionar Todo </mat-checkbox>
                        </h3>
                    </div>
                    <div *ngIf="this.rol != 'ROLE_EJECUTIVO_CAIP'">
                        <div class="col-lg-2"> <button mat-button class="mat-raised-button btn-warning" (click)="asignarSeleccionados()">

                                <i class = "fa fa-pen"></i> Asignar Seleccionados </button>
                        </div>
                    </div>
                    <div class="col-lg-5"> </div>
                    <div class="col-lg-2">



                    </div>

                </div> <br/>

            </div>
            <br/>
            <div class="table-responsive">

                <table class="table">

                    <thead style="background-color: #0f69b4;color:white;">

                        <tr>
                            <th *ngIf="tipoPostulacion == 'Disponibles'"> </th>
                            <th>N°</th>
                            <th>Fecha Ingreso</th>
                            <th>Rut Afiliado</th>
                            <th>Nombre Afiliado</th>
                            <th>Categoría de Atención</th>
                            <th>Región</th>
                            <th>Proveedor</th>
                            <th>Monto Solicitado</th>
                            <th>Cantidad de Cuotas</th>

                            <th>Estado</th>
                            <th>Ejecutivo</th>

                            <th> </th>
                        </tr>

                    </thead>

                    <tbody>

                        <tr [class]="i % 2 == 0 ? 'rowEven' : 'rowOdd'" *ngFor="let postulacion of postulaciones | paginate: config; let i = index">

                            <td style="text-align: center;" *ngIf="tipoPostulacion == 'Disponibles' &&
                            ( postulacion.estado == 'INGRESADA'
                            || ((this.rol == 'ROLE_ADMINISTRADOR' || this.rol == 'ROLE_ENCARGADO_NACIONAL') && tipoPostulacion == 'Disponibles' && postulacion.estado != 'PAGADA')
                            || (postulacion.estado == 'EN VALIDACION' && tipoPostulacion == 'Disponibles')
                            || (postulacion.estado == 'RECHAZADA' && tipoPostulacion == 'Disponibles')
                            )
                             ">

                                <mat-checkbox [(ngModel)]="postulacion.seleccionado" color="primary" (ngModelChange)="updateAllComplete()"> </mat-checkbox>

                            </td>
                            <td style="text-align: center;" *ngIf="this.rol != 'ROLE_ADMINISTRADOR'
                            && tipoPostulacion == 'Disponibles' && (
                             postulacion.estado == 'PAGADA'
                            || postulacion.estado == 'APROBADA'
                              || postulacion.estado == 'ANULADA'
                            || (postulacion.estado == 'DISPONIBLE PARA PAGO' && this.rol != 'ROLE_ADMINISTRADOR' && tipoPostulacion == 'Disponibles')
                            ) ">

                            </td>


                            <td style="text-align: center;" *ngIf="postulacion.estado == 'PAGADA' || postulacion.estado == 'ANULADA'"></td>

                            <td style="text-align: center;"><a style="cursor:pointer; text-decoration: underline" (click)="openEditDialogValidarConvenio(postulacion.idPostulacion,  false,false)">{{postulacion.idPostulacion}}</a> </td>
                            <td style="text-align: center;"> {{postulacion.fechaIngreso}} </td>
                            <!-- 
                            <td style="text-align: center;" *ngIf="postulacion.idCarga == 0"> <a (click)="detalleBeneficiario(postulacion.rutUsuario)" style="cursor:pointer; text-decoration: underline;"> {{postulacion.rutUsuario}} </a> </td>
                            <td style="text-align: center;" *ngIf="postulacion.idCarga != 0"> {{postulacion.rutCarga}} </td>
                            <td style="text-align: center;" *ngIf="postulacion.idCarga == 0"> {{postulacion.nombreUsuario}} </td>
                            <td style="text-align: center;" *ngIf="postulacion.idCarga != 0"> {{postulacion.nombreCarga}}
                            </td>
                            -->
                            <td style="text-align: center;" > <a (click)="detalleBeneficiario(postulacion.rutUsuario)" style="cursor:pointer; text-decoration: underline;"> {{postulacion.rutUsuario}} </a> </td>
                            <td style="text-align: center;" > {{postulacion.nombreUsuario}} </td>

                            <td style="text-align: center;"> {{postulacion.tipoConvenioString}} </td>
                            <td style="text-align: center;"> {{postulacion.regionConvenio}} </td>
                            <td style="text-align: center;"> {{postulacion.nombreCorto}} </td>
                            <td style="text-align: center;"> {{postulacion.montoSolicitado}} </td>
                            <td style="text-align: center;"> {{postulacion.cantidadCuota}} </td>
                            <td style="text-align: center;" *ngIf="postulacion.estado == 'RECHAZADA'"> <a (click)="detalleRechazoBeneficiario(postulacion.idPostulacion)" style="cursor:pointer; text-decoration: underline;">{{postulacion.estado}} </a></td>
                            <td style="text-align: center;" *ngIf="postulacion.estado != 'RECHAZADA'"> {{postulacion.estado}}</td>
                            <td style="text-align: center;">{{postulacion.nombreEjecutivo}} </td>
                            <td style="text-align: center;">
                                <button *ngIf="tipoPostulacion == 'Asignadas' && postulacion.estado == 'EN VALIDACION'" class="btn btn-success" style="width: 120px" (click)="openEditDialogValidarConvenio(postulacion.idPostulacion,  true,true)">

                                    <i class = "fa fa-pen"> </i> Gestionar

                                </button>

                                <button *ngIf="tipoPostulacion == 'Asignadas' && postulacion.estado !='EN VALIDACION'" class="btn btn-warning" (click)="openEditDialogValidarConvenio(postulacion.idPostulacion,  false,false)" style="width: 120px">

                                        <i class = "fa fa-pen"> </i> Revisar

                                    </button>
                           
                                <div *ngIf="this.rol != 'ROLE_EJECUTIVO_CAIP'">
                                    <button *ngIf="(tipoPostulacion == 'Disponibles' && postulacion.estado != 'PAGADA' && postulacion.estado != 'ANULADA' && postulacion.estado !='PENDIENTE'   
                                    && postulacion.estado == 'INGRESADA'
                                    && ((this.rol == 'ROLE_ADMINISTRADOR' || this.rol == 'ROLE_CONTABILIDAD' || this.rol == 'ROLE_ENCARGADO_CONTABILIDAD' || this.rol == 'ROLE_ASISTENTE_SOCIAL' || this.rol == 'ROLE_ENCARGADO_REGIONAL' || this.rol == 'ROLE_ENCARGADO_REGIONAL_CONTABLE') && tipoPostulacion == 'Disponibles' && postulacion.estado != 'PAGADA' && postulacion.estado !='PENDIENTE')
                                    || (postulacion.estado == 'EN VALIDACION' && tipoPostulacion == 'Disponibles' && (this.rol == 'ROLE_ADMINISTRADOR' || this.rol == 'ROLE_ENCARGADO_CONTABILIDAD' || this.rol == 'ROLE_CONTABILIDAD' || this.rol == 'ROLE_ASISTENTE_SOCIAL' || this.rol == 'ROLE_ENCARGADO_REGIONAL' || this.rol == 'ROLE_ENCARGADO_REGIONAL_CONTABLE')) 
                                    || (postulacion.estado == 'RECHAZADA' && tipoPostulacion == 'Disponibles' && this.rol == 'ROLE_ADMINISTRADOR')
                                    || (postulacion.estado == 'DISPONIBLE PARA PAGO'  && tipoPostulacion == 'Disponibles' && this.rol == 'ROLE_ADMINISTRADOR')
                                    ) && (idUsuario!=postulacion.idEjecutivo && tipoPostulacion == 'Disponibles')
                                    ;else noAsigna
                                    " class="btn btn-warning" style="width: 120px" (click)="asignaPostulacion(postulacion.idPostulacion)">

                                        <i class = "fa fa-pen"> </i> Asignar

                                    </button>

                                </div>
                                <ng-template #noAsigna>
                                    <button *ngIf="tipoPostulacion == 'Disponibles'" class="btn btn-secondary" style="width: 120px" disabled>
                                   Sin acciones
                                  </button>
                                </ng-template>
                            </td>

                        </tr>

                    </tbody>

                </table> <br/>

                <pagination-controls style="text-align: center" previousLabel="Anterior" nextLabel="Siguiente" (pageChange)="pageChanged($event)" autoHide="true"> </pagination-controls>

            </div>

        </div>

        <div class="container" style="height:100px"> </div>

    </div>

</div>